import Axios from "axios";
import {
  UPDATE_PAYMENT_ORDER,
  POST_PAYMENT_ORDER,
  EDIT_PAYMENT_ORDER,
  DELETE_PAYMENT_ORDER,
  GET_WAITING_PAYMENTS,
  CREATE_WAITING_PAYMENT,
} from "./types";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;
import { success } from "./modalsFunctios";
import { antdAsyncMessageError, antdAsyncMessageLoading, antdAsyncMessageSuccess } from "../../helpers/AsyncMessage";

export const resendWaitingPayment = (orderId, id) => async (dispatch) => {
  const params = {
    waiting_payment: {
      payment_id: id,
    },
  };

  try {
    const { data } = await Axios.post(
      `/api/v1/orders/${orderId}/waiting_payments/resend_custom_payment`,
      params
    );
    return { success: true };
  } catch (e) {
    console.log("error resending waiting payment");
    return { suceess: false };
  }
};

export const getWaitingPayments = (orderId) => async (dispatch) => {
  try {
    const { data } = await Axios.get(
      `/api/v1/orders/${orderId}/waiting_payments/`
    );
    dispatch({
      type: GET_WAITING_PAYMENTS,
      payload: data,
    });
    return { success: true };
  } catch (e) {
    console.log("error getting waiting payments");
    return { suceess: false };
  }
};

export const getPaymentsTypesOptions = async (order_shop_id = null) => {
  try {
    const { data } = await Axios.get(`/api/v1/payment_types?per_page=99999${!!order_shop_id ? `&q[order_shop_id_eq]=${order_shop_id}` : '&q[order_shop_id_null]=0'}`);
    return {
      success: true, data: data.data.map(d => ({
        ...d,
        value: d.title,
        label: `[${d?.order_shop?.identifier || ""}] ${d.title}`,
      }))
    };
  } catch (err) {
    console.error("error getting waiting payments: ", err);
    return { suceess: false, data: [] };
  }
};

export const createWaitingPayment =
  (orderId, service, price, cod = false) =>
    async (dispatch) => {
      const params = {
        waiting_payment: {
          order_id: orderId,
          service,
          price: +price,
          cod,
        },
      };

      try {
        const { data } = await Axios.post(
          `/api/v1/orders/${orderId}/waiting_payments/send_custom_montonio_payment`,
          params
        );
        dispatch({
          type: CREATE_WAITING_PAYMENT,
          payload: data.waiting_payment,
        });
        dispatch({
          type: "ORDER_COD_UPDATE",
          payload: {
            cod: data.cod,
            order_id: orderId,
          },
        });
        return { success: true };
      } catch (e) {
        console.log("error creating waiting payment: ", e);
        return { success: false, errors: e.response.data || "Įvyko klaida" };
      }
    };

export const removeWaitingPayment =
  (order_id, waiting_payment_id) =>
    async (dispatch) => {
      const key = "removeWaitingPayment"

      try {
        antdAsyncMessageLoading({ key })
        const { data } = await Axios.delete(
          `/api/v1/orders/${order_id}/waiting_payments/${waiting_payment_id}`
        );
        if (!data?.success) throw new Error('Something went wrong');
        antdAsyncMessageSuccess({ key })
        dispatch({
          type: "REMOVE_WAITING_PAYMENT",
          payload: {
            waiting_payment_id,
            order_id,
          }
        })
        dispatch({
          type: "ORDER_COD_UPDATE",
          payload: {
            cod: data.cod,
            order_id,
          },
        });
        return { success: true };
      } catch (e) {
        antdAsyncMessageError({ key, text: e?.message })
        return { success: false };
      }
    };

export const postPayment = (orderId, body) => (dispatch) => {
  return Axios.post(`/api/v1/orders/${orderId}/payments`, body)
    .then((res) => {
      dispatch({
        type: POST_PAYMENT_ORDER,
        payload: res.data,
      });
      return { success: true };
    })
    .catch((err) => {
      return { success: false, errors: err.response.data };
    });
};

export const editPayment = (variables) => (dispatch) => {
  dispatch({
    type: EDIT_PAYMENT_ORDER,
    payload: variables,
  });
};
export const updatePayment = (orderId, id, body) => (dispatch) => {
  return Axios.put(`/api/v1/orders/${orderId}/payments/${id}`, body)
    .then((res) => {
      dispatch({
        type: UPDATE_PAYMENT_ORDER,
        payload: res.data,
      });
      return { success: true };
      success("paymentTypes-s", "modalClose");
    })
    .catch((err) => {
      return { success: false, errors: err.response.data };
    });
};

export const deletePayment = (orderId, id) => (dispatch) => {
  return Axios.delete(`/api/v1/orders/${orderId}/payments/${id}`)
    .then((res) => {
      dispatch({
        type: DELETE_PAYMENT_ORDER,
        payload: id,
      });
      return true;
      success("paymentTypes-s", "modalClose");
    })
    .catch((err) => {
      if (err.response.data) {
        return err.response.data;
      }
    });
};
